import { Capacitor } from '@capacitor/core'
import { nanoid } from 'nanoid'

const DEVICE_ID_KEY = 'cs_crew_device_id'

/** The persisted device id on native, created and stored on first call; the
 * constant 'web' on web. Synchronous: no I/O beyond localStorage. */
export const ensureDeviceId = (): string => {
  if (!Capacitor.isNativePlatform()) return 'web'
  const stored = localStorage.getItem(DEVICE_ID_KEY)
  if (stored) return stored
  const id = nanoid(16)
  localStorage.setItem(DEVICE_ID_KEY, id)
  return id
}
